<pages-container
  [title]="'main.forumBanner'"
  [icon]="'planner_banner_ad_pt'">
  <div buttons>
    <button mat-raised-button
            class="mat-white-bg"
    (click)="addBanner()">
      <span>{{ 'main.add' | translate }}</span>
    </button>
  </div>

  <div main-content class="banner-list">
    <div class="table-container" id="bannersPage">
      @if (banners()?.length) {
        <mat-table class="products-table"
                   #table
                   [dataSource]="banners()"
                   (matSortChange)="sortData($event)"
                   matSort>
          <ng-container matColumnDef="text">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.text' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let banner" class="customWidthClass">
              <p class="text-truncate">{{ banner.text }}</p>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dateFrom">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.date_from' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let banner" class="customWidthClass">
              <p class="text-truncate">{{ banner.dateFrom | date: 'dd.MM.yyyy HH:mm'}}</p>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="dateTo">
            <mat-header-cell class="customWidthClass" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.date_to' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let banner" class="customWidthClass">
              <p class="text-truncate">{{ banner.dateTo | date: 'dd.MM.yyyy HH:mm'}}</p>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="active">
            <mat-header-cell class="customWidthClassIcon" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.active' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let banner" class="customWidthClassIcon">
              @if (!banner.active) {
                <mat-icon class="mat-icon-inactive">cancel</mat-icon>
              } @else {
                <mat-icon class="mat-icon-active">check_circle</mat-icon>
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="edit">
            <mat-header-cell class="customWidthClassIcon" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.edit' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let banner" class="customWidthClassIcon">
              <mat-icon class="mat-icon-edit" (click)="editBanner(banner)">edit</mat-icon>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="delete">
            <mat-header-cell class="customWidthClassIcon" *matHeaderCellDef mat-sort-header>
              {{ 'forumTalk.delete' | translate }}
            </mat-header-cell>
            <mat-cell *matCellDef="let banner" class="customWidthClassIcon">
              <mat-icon class="mat-icon-delete" (click)="deleteBanner(banner)">delete</mat-icon>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let banner; columns: displayedColumns;"
                   class="banner-row"
                   matRipple>
          </mat-row>
        </mat-table>
        <mat-paginator [length]="pagination()?.total"
                       [pageIndex]="pageIndex()"
                       [pageSize]="perPage()"
                       [pageSizeOptions]="[25, 50, 100]"
                       (page)="handlePageEvent($event)">
        </mat-paginator>
      }
    </div>
    @if (!banners()?.length) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{ 'main.noData' | translate }}</span>
      </div>
    }
  </div>
</pages-container>
